import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
// import loginValidation from './loginValidation'
import { Input } from 'components/fields'
import { Form } from 'components/layout'
import { Button } from 'components/misc'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Login',
  intlKey: 'pageTitle.login'
})
@reduxForm({
  form: 'login'
})
class FormLogin extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    submitting: PropTypes.bool,
    dirty: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired
  }

  static defaultProps = {
    loading: false
  }

  render() {
    const { dirty, loading, handleSubmit, submitting } = this.props

    return (
      <div>
        <Form className="form-horizontal" onSubmit={handleSubmit}>
          <Input
            name="username"
            label="Email"
            intlKey="label.email"
          />
          <Input
            name="password"
            label="Password"
            type="password"
            intlKey="label.password"
          />

          <Button
            onClick={handleSubmit}
            disabled={!dirty || loading}
            intlKey="button.login"
            isLoading={submitting}
          >
            Login
          </Button>
        </Form>
      </div>
    )
  }
}

export default FormLogin
